<script setup>
import IconBase from '../icon/IconBase.vue';
import IconChevronRight from '../icon/IconChevronRight.vue';

defineProps({
	// items: [{ label: String, to?: String }] — last item is the current page
	items: { type: Array, default: () => [] },
});
</script>

<template>
	<nav class="flex items-center flex-wrap gap-x-1 gap-y-1 text-sm" aria-label="Breadcrumb">
		<template v-for="(item, index) in items" :key="index">
			<router-link v-if="item.to && index < items.length - 1" :to="item.to"
				class="text-surface-8 hover:text-white hover:no-underline transition truncate max-w-[220px]">
				{{ item.label }}
			</router-link>
			<span v-else class="truncate max-w-[260px]"
				:class="index === items.length - 1 ? 'text-white' : 'text-surface-8'">
				{{ item.label }}
			</span>
			<icon-base v-if="index < items.length - 1" class="text-surface-7 shrink-0" fill="none">
				<icon-chevron-right />
			</icon-base>
		</template>
	</nav>
</template>
